<main class="main c12">
    <div>
        <article class="card box">
            <h2>Ejeplos de tabla</h2>
            <ul>
                <li class="link" (click)="verTabla('basica')">Tabla con buscador básica</li>
                <li class="link" (click)="verTabla('selectable')">Tabla con items seleccionables (:hover)</li>
                <li class="link" (click)="verTabla('botones')">Tabla con acciones personalizables</li>
                <li class="link" (click)="verTabla('checkeable')">Tabla checkeable</li>
                <li class="link" (click)="verTabla('disabled')">Tabla con items deshabilitados</li>
                <li class="link" (click)="verTabla('long')">Tabla larga</li>
                <li class="link" (click)="verTabla('custom')">Tabla con custom labels</li>
            </ul>
        </article>
    </div>
    <article class="card">
        <tabla-busqueda *ngIf="content=='basica'"
            [titulo]="'Tabla básica'"
            [lista]="data_ejemplo"
            [columnas]="columnas"
        >
        </tabla-busqueda>

        <tabla-busqueda *ngIf="content=='selectable'"
            [titulo]="'Tabla seleccionable'"
            [lista]="data_ejemplo"
            [columnas]="columnas"
            [selectable]="true"
            (selectTupla)="select($event,modal)"
        >
        </tabla-busqueda>

        <tabla-busqueda *ngIf="content=='botones'"
            [titulo]="'Tabla con íconos personalizables'"
            [lista]="lista_chequeable"
            [columnas]="extendida? columnasExt: columnas"
            [labels]="extendida? columnasExt: columnas"
            [tdExtra]="{td:'bi bi-info-circle',th: !extendida?'bi bi-chevron-bar-right':'bi bi-chevron-bar-left'}"
            (selectAll)="extender()"
            (selectTupla)="select($event,modal)"
        >
        </tabla-busqueda>

        <tabla-busqueda *ngIf="content=='checkeable'"
            [titulo]="'Tabla con checkfields'"
            [lista]="data_ejemplo"
            [columnas]="columnas"
            [checkeable]="true"
            (selectAll)="checkall($event)"
            (selectTupla)="check($event)"
            [tdExtra]="{all:todos}"
        >
        </tabla-busqueda>

        <tabla-busqueda *ngIf="content=='disabled'"
            [titulo]="'Tabla con elementos deshabilitados'"
            [lista]="lista_chequeable"
            [columnas]="extendida? columnasExt: columnas"
            [tdExtra]="{td:'bi bi-info-circle',th: !extendida?'bi bi-chevron-bar-right':'bi bi-chevron-bar-left'}"
            (selectAll)="extender()"
            (selectTupla)="select($event,modal)"
            [disabled]="'gato'"
        >
        </tabla-busqueda>

        <tabla-busqueda *ngIf="content=='long'"
            [titulo]="'Tabla Larga con scroll'"
            [lista]="data_replicada"
            [columnas]="columnas"
        >
        </tabla-busqueda>

        <tabla-busqueda *ngIf="content=='custom'"
            [titulo]="'Tabla Con custom labels'"
            [lista]="data_ejemplo"
            [columnas]="columnasExt"
            [labels]="labels"
        >
        </tabla-busqueda>
        
    </article>
</main>

<ng-template let-modal #modal>
    <section >
        <div class="modal-header">
            <h3 >Un PopUp</h3>
            <button class="btn link bi bi-x-lg" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body campos" *ngIf="seleccionado">
            <label>Nombre:</label>
            <p>{{seleccionado.nombre}}</p>
            <label>Raza:</label>
            <p>{{seleccionado.raza}}</p>
            <label>Edad:</label>
            <p>{{seleccionado.edad}} años</p>
        </div>
    </section>
</ng-template>

